export function num(v) {
  if (v == null) return 0;
  let s = String(v).trim();
  if (!s) return 0;
  s = s.replace("½", "0.5");
  const frac = s.match(/^(\d+)\s*\/\s*(\d+)/);
  if (frac) return parseInt(frac[1], 10) / parseInt(frac[2], 10);
  const m = s.match(/[\d.]+/);
  return m ? parseFloat(m[0]) : 0;
}

// (Morning + Afternoon + Night) * Number of days
export function computeMedTotal(m) {
  const perDay = num(m.morning) + num(m.afternoon) + num(m.night);
  const days = num(m.duration);
  const t = perDay * days;
  return t > 0 ? String(t) : "";
}
